import { Avatar } from "primereact/avatar";
import PropTypes from "prop-types";
import React from "react";

const FlaggedMessage = ({ messageInfo, formatDate }) => {
  const isFlagged = messageInfo.is_flagged;

  const role = {
    GXM_ADMIN: "GXM Admin",
    CUSTOMER: "Customer",
    LSP_USER: "Local Team",
    GXM_USER: "GXM User",
    GXM_MANAGER: "GXM Manager",
    LSP_MANAGER: "Local Team Manager",
    CUSTOMER_MANAGER: "Customer Manager",
  };

  const getUserDisplayName = (userData) => {
    if (!userData) return "Unknown User";
    const firstName = userData.first_name || "";
    const lastName = userData.last_name || "";
    const fullName = `${firstName} ${lastName}`.trim();
    return fullName || "Unknown User";
  };

  const getRoleDisplay = (userData) => {
    if (!userData?.role) return "";
    return role[userData.role] || userData.role;
  };

  const getMessageHeader = () => {
    const flagStatusText = isFlagged ? "has been flagged" : "flag was removed";
    const userName = getUserDisplayName(messageInfo?.userData);
    const userRole = getRoleDisplay(messageInfo?.userData);
    return `${messageInfo?.taskData?.name} ${flagStatusText} by ${userName}${userRole ? ` (${userRole})` : ""}`;
  };

  return (
    <div className="message-container">
      <Avatar
        icon={isFlagged ? "pi pi-flag-fill" : "pi pi-flag"}
        shape="square"
        className="flagged"
      />
      <div className="message-content">
        <div className="meta-info">
          <p className="user-name">{getMessageHeader()} </p>
          <p className="date-time">{formatDate(messageInfo?.createdAt)}</p>
        </div>
        <p className="message">{messageInfo?.content}</p>
      </div>
    </div>
  );
};

FlaggedMessage.proptypes = {
  messageInfo: PropTypes.any,
  formatDate: PropTypes.func,
  status: PropTypes.string,
};

export default FlaggedMessage;
